export default __webpack_public_path__ + "static/media/img_1.03e8e912.jpg";